<template>
  <div class="page">
    <PageHeader>
      Карты для RTAPI
    </PageHeader>
    <div class="content">
      <el-card
        shadow="always"
        :body-style="{ padding: '20px' }"
        v-loading="loading"
      >
        <el-row :gutter="20">
          <el-col :span="18" :offset="0">
            <el-input
              v-model="search"
              placeholder="Поиск..."
              size="normal"
              clearable
              @change="performSearch"
            ></el-input>
          </el-col>
          <el-col :span="6" :offset="0">
            <el-button type="primary" size="default" @click="performSearch"
              >Поиск</el-button
            >
            <el-button type="primary" size="default" @click="resetSearch"
              >Сброс</el-button
            >
          </el-col>
        </el-row>

        <div v-if="cards.docs">
          <el-table
            :data="cards.docs"
            @sort-change="handleSortChange"
            :default-sort="{ prop: '_id', order: 'descending' }"
            :row-class-name="tableRowClassName"
            border
            stripe
          >
            <el-table-column sortable="custom" prop="_id" label="ID" width="90">
              <template slot-scope="scope">
                <i v-if="scope.row.isNew" class="el-icon-document-add"></i>
                {{ scope.row._id.slice(-6) }}
              </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="number" label="Номер карты">
            </el-table-column>
            <el-table-column
              v-if="session.type <= -1"
              fixed="right"
              label="Действия"
              width="150"
            >
              <template slot-scope="scope">
                <el-tooltip placement="top">
                  <div slot="content">Удалить</div>
                  <el-button
                    size="small"
                    icon="el-icon-delete"
                    @click="handleDeleteItem(scope.row._id)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip placement="top">
                  <div slot="content">Редактировать</div>
                  <el-button
                    size="small"
                    icon="el-icon-edit"
                    @click="handleEditItem(scope.row._id)"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handlePageChange"
            :current-page.sync="cards.page"
            :page-size="cards.limit"
            layout="prev, pager, next, jumper"
            :total="cards.totalDocs"
          >
          </el-pagination>
        </div>
        <el-collapse v-model="activeCollapse">
          <el-collapse-item name="1">
            <template slot="title">
              <i class="header-icon el-icon-plus"></i>
              {{ isEditing ? "Изменить" : "Добавить" }}
            </template>
            <el-form
              :model="newCard"
              ref="form"
              label-width="280px"
              :inline="false"
              size="normal"
            >
              <el-form-item label="Номер карты">
                <el-input v-model="newCard.number"></el-input>
              </el-form-item>

              <el-form-item>
                <el-button v-if="isEditing" type="primary" @click="editItem"
                  >Сохранить</el-button
                >
                <el-button v-else type="primary" @click="addItem"
                  >Добавить</el-button
                >
                <el-button v-if="isEditing" @click="cancelEditItem"
                  >Отменить</el-button
                >
                <el-button v-else @click="resetForm">Очистить</el-button>
              </el-form-item>
            </el-form>
          </el-collapse-item>
        </el-collapse>
      </el-card>
    </div>
  </div>
</template>
<script>
import { getCards, addCard, editCard, deleteCard } from "@/api";
import { mapState, mapActions, mapGetters } from "vuex";
import PageHeader from "../../ui/PageHeader.vue";
const defaultCard = {
  number: "",
  lastAccess: null
};
export default {
  components: { PageHeader },
  name: "RTApiCardsPage",
  data: () => ({
    loading: true,
    newCard: {
      ...defaultCard
    },
    cards: [],
    page: 1,
    limit: 10,
    sort: "-_id",
    search: "",
    activeCollapse: [],
    isEditing: false
  }),
  computed: {
    ...mapState("auth", ["session"]),
    searchQuery() {
      return { $and: [{ number: { $regex: `.*${this.search}.*` } }] };
    }
  },
  methods: {
    async sleep(ms) {
      return await new Promise((resolve, reject) => {
        setTimeout(() => resolve(true), ms);
      });
    },
    async loadingWrapper(func) {
      try {
        this.loading = true;
        await func();
      } catch (error) {
        this.handleResponseError(error);
      } finally {
        this.loading = false;
      }
    },
    async getCards() {
      await this.loadingWrapper(async () => {
        const { data } = await getCards({
          page: this.page,
          limit: this.limit,
          sort: this.sort,
          query: this.searchQuery
        });
        if (data.status) this.cards = data.result;
      });
    },
    async performSearch() {
      this.page = 1;
      await this.getCards();
    },
    async resetSearch() {
      this.page = 1;
      this.search = "";
      await this.getCards();
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isNew) {
        return "new-row";
      }
      return "";
    },
    async handleDeleteItem(id) {
      let message = "Вы точно хотите удалить карту API?";
      try {
        await this.$confirm(message, "Внимание!", {
          confirmButtonText: "Удалить",
          cancelButtonText: "Отменить",
          type: "warning"
        });
        await this.loadingWrapper(async () => {
          await deleteCard(id);
        });
        await this.getCards();
        this.$message({
          type: "success",
          message: `Карта API успешно удалена`
        });
      } catch (error) {
        this.$message({
          type: "info",
          message: "Удаление отменено"
        });
      }
    },
    handleEditItem(id) {
      this.activeCollapse = ["1"];
      this.isEditing = true;
      this.newCard = { ...this.cards.docs.find(u => u._id === id) };
    },
    async handleSortChange(sortData) {
      this.sort =
        sortData.order === "ascending"
          ? sortData.prop
          : sortData.order === "descending"
          ? `-${sortData.prop}`
          : "";
      await this.getCards();
    },
    async handlePageChange(page) {
      this.page = page;
      await this.getCards();
    },
    resetForm() {
      this.newCard = {
        ...defaultCard
      };
    },
    async addItem() {
      await this.loadingWrapper(async () => {
        const data = {
          ...this.newCard
        };
        const resp = await addCard(data);
        this.resetForm();
        return this.$notify.success({
          title: "Успех",
          message: `Карта API ${resp.data.result.number || ""} добавлена!`
        });
      });
      await this.getCards();
    },
    async editItem() {
      await this.loadingWrapper(async () => {
        const data = {
          ...this.newCard
        };
        const resp = await editCard(this.newCard._id, data);
        this.isEditing = false;
        this.activeCollapse = [];
        this.resetForm();
        return this.$notify.success({
          title: "Успех",
          message: `Карта API ${resp.data.result.name || ""} изменена!`
        });
      });
      await this.getCards();
    },
    cancelEditItem() {
      this.isEditing = false;
      this.activeCollapse = [];
      this.resetForm();
    }
  },
  async mounted() {
    await this.getCards();
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/pages/Cards/index.vue